var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 24,
    viewBox: "0 0 60 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3377 6.38298C34.8011 30.5828 23.2008 28.4181 4.05182 4.66235C18.2054 8.15912 25.6984 10.1573 40.4626 8.15912C44.4033 7.60407 55.3932 2.6087 55.3377 6.43849V6.38298Z",
    fill: "#E08087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3376 6.38298C55.4487 2.6087 44.4033 7.60407 40.4625 8.10361C25.6984 10.1018 18.2609 8.10361 4.0518 4.60684C3.60777 4.0518 0 1.3321 0 0.888066L0.888067 0C11.2118 4.60684 17.0953 -1.3876 32.3589 1.72063C41.4061 -0.777058 51.4524 1.2766 60 1.99815C60 2.33117 55.8927 5.71693 55.3376 6.38298Z",
    fill: "#E58D90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.5338,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth6);
export default __webpack_public_path__ + "static/media/mouth-6.12c1e1215431716ebd86ef5898f48a19.svg";
export { ForwardRef as ReactComponent };